interface IItem {
  title: string;
  link: string;
}

interface IPolicy {
  formTerms: string;
  items: IItem[];
}

export const AGREEMENT_STORAGE_KEY = 'is-agreement-ok';

export const USER_AGREEMENT_ITEM = {
  title: 'Пользовательское соглашение',
  link: '/info/sales',
};

export const PERSONAL_INFO_ITEM = {
  title: 'Политика обработки персональных данных',
  link: '/info/processing',
};

export const WARRANTY_ITEM = {
  title: 'Гарантия и возврат',
  link: '/help/warranty',
};

export const LOYALTY_PROGRAM_ITEM = {
  title: 'Правила программы лояльности',
  link: '/info/cashback',
};

export const POLICY: IPolicy = {
  formTerms: `Подписываясь на&nbsp;рассылку, я&nbsp;соглашаюсь с&nbsp;<a href="${USER_AGREEMENT_ITEM.link}">условиями обработки персональных данных</a>`,
  items: [
    USER_AGREEMENT_ITEM,
    PERSONAL_INFO_ITEM,
  ],
};
